var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('div',{staticClass:"sidebar-navigation"},[_vm._t("default")],2),_c('div',{staticClass:"sidebar-navigation-bottom"},[_vm._t("bottom")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }